import { call, put } from 'redux-saga/effects';
import { backendClient } from '../../../services/api/backend-client';
import { setCrmCatalog } from '../../../state/integration/integrationSlice';
import bugsnagClient from '../../../services/bugsnag/bugsnag';

export function* fetchCrmCatalogSaga() {
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            'integrations/catalog'
        );
        yield put(setCrmCatalog(data.catalog || []));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to fetch CRM catalog', err?.response?.status, err?.message);
    }
}
